export const promotionsController = {
  initial: 'off',
  states: {
    off: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'on',
          cond: 'arePromotionsEnabled',
        },
      },
    },
    on: {
      entry: {
        type: 'batchLayoutOperations',
        data: [
          {
            type: 'setLayoutProperty',
            data: {
              path: 'components.Modal.properties.titleKey',
              value: 'promotionTitle',
            },
          },
        ],
      },
      initial: 'initializingHeader',
      states: {
        initializingHeader: {
          always: [
            {
              target: 'waitingForModal',
              cond: 'isHeaderInitialized',
            },
            {
              target: 'waitingForHeader',
            },
          ],
        },
        waitingForHeader: {
          invoke: {
            src: 'waitForHeader',
          },
          on: {
            WH_HEADER_INITIALIZED: 'waitingForModal',
            WH_HEADER_TIMEOUT: 'headerErrored',
          },
        },
        waitingForModal: {
          invoke: {
            src: 'waitForPromotionsModal',
          },
          on: {
            MODAL_LOADED: 'view_loaded',
            MODAL_TIMEOUT: 'headerErrored',
          },
        },
        view_loaded: {
          invoke: {
            src: 'watchPromotionsEvents',
          },
          initial: 'initializingPromotions',
          states: {
            initializingPromotions: {
              invoke: {
                src: 'initializePromotions',
                onDone: [
                  {
                    target: 'locationChangingToDetails',
                    cond: 'isPromotionsDetailsPage',
                  },
                  {
                    target: 'locationChangingToList',
                  },
                ],
              },
            },
            locationChangingToDetails: {
              entry: 'showPromotionDetails',
              on: {
                PROMOTION_DETAILS_DISPLAYED: {
                  actions: [
                    'promotions_updateUrl',
                    'tracking_changePage',
                    'updatePrevPageArray',
                    'updateCurrentPagePath',
                  ],
                  target: 'promotionsDetailsVisible',
                },
              },
            },
            locationChangingToList: {
              entry: 'showPromotionsList',
              always: 'promotionsListVisible',
            },
            promotionsListVisible: {
              entry: {
                type: 'setLayoutProperty',
                data: {
                  path: 'components.Modal.properties.backButtonVisible',
                  value: false,
                },
              },
              on: {
                PROMOTION_DETAILS_DISPLAYED: {
                  actions: [
                    'promotions_updateUrl',
                    'tracking_changePage',
                    'updatePrevPageArray',
                    'updateCurrentPagePath',
                  ],
                  target: 'promotionsDetailsVisible',
                },
              },
            },
            promotionsDetailsVisible: {
              entry: {
                type: 'setLayoutProperty',
                data: {
                  path: 'components.Modal.properties.backButtonVisible',
                  value: true,
                },
              },
              on: {
                PROMOTION_LIST_DISPLAYED: {
                  actions: [
                    'updatePrevPageArray',
                    'updateCurrentPagePath',
                    'promotions_updateUrl',
                    'tracking_changePage',
                  ],
                  target: 'promotionsListVisible',
                },
                VIEW_MODAL_BACK_BUTTON_CLICK: {
                  actions: ['showPromotionsList'],
                  target: 'goToPreviousPage',
                },
              },
            },
            goToPreviousPage: {
              invoke: {
                src: 'fetchPreviousPageInfo',
                onDone: {
                  actions: [
                    {
                      type: 'save',
                      data: {
                        previousPageArray: '$event.data.previousPageArray',
                      },
                      meta: {
                        selectors: ['$action.data.previousPageArray'],
                      },
                    },
                    'updateCurrentPagePath',
                    'promotions_updateUrl',
                  ],
                  target: 'promotionsListVisible',
                },
              },
            },
          },
        },
        headerErrored: {
          entry: {
            type: 'setLayoutProperty',
            data: {
              path: 'components.PromotionsBasecamp.properties',
              value: {
                error: {
                  message: 'Error occured while loading Promotions',
                },
              },
            },
          },
        },
      },
      on: {
        LAYOUT_CHANGE_END: [
          {
            target: 'off',
            cond: 'isControllerDisabled_promotions',
          },
          {
            target: 'refreshing',
          },
        ],
      },
    },
    refreshing: {
      always: 'on',
    },
  },
};
